module.exports = __webpack_public_path__ + "0247511485aa6f2c787a11f38ad78d64.png";